'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _StateBrowserNetwork = require('@/components/StateBrowserNetwork.vue');

var _StateBrowserNetwork2 = _interopRequireDefault(_StateBrowserNetwork);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_StateBrowserNetwork2.default],
    data: function data() {
        return {
            private_add_display: false,
            private_add_input: '',
            private_add_input_has_focus: false,
            channels_collapsed_down: false,
            private_channels_collapsed_down: false
        };
    },

    computed: {
        filteredChannels: function filteredChannels() {
            return this.filteredBuffers.filter(function (buffer) {
                return !buffer.isQuery();
            });
        },
        filteredPrivate: function filteredPrivate() {
            return this.filteredBuffers.filter(function (buffer) {
                return buffer.isQuery();
            });
        }
    },
    watch: {
        private_add_display: function private_add_display(value) {
            var _this = this;

            if (this.private_add_display) {
                this.private_add_input = '';
            }
            if (this.$state.isIos && this.private_add_display) {
                this.$nextTick(function () {
                    _this.$refs['privateAddInput'].focus();
                    _this.$emit('private_add_focus', _this.$refs['privateAddInput'].getBoundingClientRect().top);
                });
            } else {
                this.$emit('private_add_blur');
            }
        }
    },
    methods: {
        toggleAddPrivate: function toggleAddPrivate() {
            if (this.channel_filter_display) {
                this.channel_filter_display = false;
            }
            if (this.channel_add_display) {
                this.channel_add_display = false;
            }

            this.private_add_display = !this.private_add_display;

            if (this.$state.isAndroid) {
                this.$parent.isAndroidKeyboardOpened = true;
            }
        },
        toggleAddChannel: function toggleAddChannel() {
            if (this.channel_filter_display) {
                this.channel_filter_display = false;
            }
            if (this.private_add_display) {
                this.private_add_display = false;
            }
            this.channel_add_display = !this.channel_add_display;
            if (this.$state.isAndroid) {
                this.$parent.isAndroidKeyboardOpened = true;
            }
        },
        toggleFilterChannel: function toggleFilterChannel() {
            this.channel_add_display = false;
            this.private_add_display = false;
            this.channel_filter_display = !this.channel_filter_display;
            if (this.$state.isAndroid) {
                this.$parent.isAndroidKeyboardOpened = false;
            }
        },
        onNewChannelInputBlur: function onNewChannelInputBlur() {
            if (this.channel_add_input === '#') {
                this.channel_add_input = '';
            }

            if (!this.channel_add_input) {
                this.channel_add_display = false;
                if (this.$state.isAndroid) {
                    this.$parent.isAndroidKeyboardOpened = false;
                }
            }

            this.channel_add_input_has_focus = false;
        },
        openChannelSearch: function openChannelSearch() {
            var _this2 = this;

            this.setActiveBuffer(this.network.serverBuffer());
            this.$nextTick(function () {
                return _this2.$state.$emit('server.tab.show', 'channels');
            });
        },
        onNewPrivateInputFocus: function onNewPrivateInputFocus() {
            this.private_add_input_has_focus = true;
        },
        onNewPrivateInputBlur: function onNewPrivateInputBlur() {
            if (!this.private_add_input) {
                this.private_add_display = false;
                if (this.$state.isAndroid) {
                    this.$parent.isAndroidKeyboardOpened = false;
                }
            }

            this.private_add_input_has_focus = false;
        },
        submitNewChannelForm: function submitNewChannelForm() {
            var newChannelVal = this.channel_add_input;
            this.channel_add_input = '#';

            var network = this.network;
            var bufferObjs = Misc.extractBuffers(newChannelVal);

            var hasSwitchedActiveBuffer = false;
            bufferObjs.forEach(function (bufferObj) {
                var chanName = bufferObj.name;
                var ignoreNames = ['#0', '0', '&0'];
                if (ignoreNames.indexOf(chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
                    return;
                }

                var newBuffer = _state2.default.addBuffer(network.id, chanName);
                if (newBuffer && !hasSwitchedActiveBuffer) {
                    _state2.default.setActiveBuffer(network.id, newBuffer.name);
                    hasSwitchedActiveBuffer = true;
                }

                if (bufferObj.key) {
                    newBuffer.key = bufferObj.key;
                }

                if (network.isChannelName(chanName)) {
                    network.ircClient.join(chanName, bufferObj.key);
                }
            });

            this.channel_add_display = false;
            if (this.$state.isAndroid) {
                this.$parent.isAndroidKeyboardOpened = false;
            }
        },
        submitNewPrivateForm: function submitNewPrivateForm() {
            var newPrivateVal = this.private_add_input;

            var network = this.network;
            var bufferObjs = Misc.extractBuffers(newPrivateVal);

            var hasSwitchedActiveBuffer = false;
            bufferObjs.forEach(function (bufferObj) {
                var chanName = bufferObj.name;
                var ignoreNames = ['#0', '0', '&0'];
                if (ignoreNames.indexOf(chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
                    return;
                }

                var newBuffer = _state2.default.addBuffer(network.id, chanName);
                if (newBuffer && !hasSwitchedActiveBuffer) {
                    _state2.default.setActiveBuffer(network.id, newBuffer.name);
                    hasSwitchedActiveBuffer = true;
                }

                if (bufferObj.key) {
                    newBuffer.key = bufferObj.key;
                }

                if (network.isChannelName(chanName)) {
                    network.ircClient.join(chanName, bufferObj.key);
                }
            });

            this.private_add_display = false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/StateBrowserNetwork.vue
// module id = 9iym
// module chunks = 1